import React, { useState, useEffect } from "react";
import { Button, Modal, Steps, Row } from "antd";
import MtFirstStep from "./mtFirstStep";
import MtSecondStep from "./mtSecondStep";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const MtSinglePackage = () => {
  const { id } = useParams();
  const [current, setCurrent] = useState(0);
  const [reserveList, setReserveList] = useState(null);
  const [packageDetails, setPackageDetails] = useState();
  const [isContractSigned, setIsContractSigned] = useState(false);
  const navigate = useNavigate();

  const changeSelectedDates = (datesList) => {
    setReserveList(datesList);
  };

  const GETPACKAGE = gql`
    query ($id: ID!) {
      getPackage(id: $id) {
        name
        description
        packageType
        product {
          name
          id
        }
        days
        sessions
        amountRial
        strikethroughRial
        contract
      }
    }
  `;

  const [getPackageData, packageData] = useLazyQuery(GETPACKAGE, {
    fetchPolicy: "no-cache",
    onCompleted({ getPackage }) {
      const {
        name,
        packageType,
        product,
        description,
        days,
        sessions,
        amountRial,
        strikethroughRial,
        contract
      } = getPackage;
      const packageData = {
        name,
        packageType,
        product,
        description,
        days,
        sessions,
        amountRial,
        strikethroughRial,
        contract
      };
      setPackageDetails(packageData);
    },
  });

  const REQUESTMEETINGROOM = gql`
    mutation (
      $productId: ID!
      $packageId: ID!
      $reserveList: [MeetingRoomReserveInput!]!
    ) {
      createMeetingRoomInvoice(
        productId: $productId
        packageId: $packageId
        reserveList: $reserveList
      ) {
        id
      }
    }
  `;
  const [runRequestMeetingRoom, requestMeetingRoom] = useMutation(
    REQUESTMEETINGROOM,
    {
      onError(err) {
        Modal.error({
          title: err.message,
          okText: 'باشه'
        });
      },
      onCompleted(data) {
        navigate(`/invoice/${data.createMeetingRoomInvoice.id}`);
      },
    }
  );

  const createInvoice = () => {
    runRequestMeetingRoom({
      variables: {
        productId: packageDetails?.product?.id,
        packageId: id,
        reserveList,
      },
    });

  };
  useEffect(() => {
    if (id) {
      getPackageData({
        variables: {
          id,
        },
      });
    }
  }, [id]);

  const steps = [
    {
      title: "مشخصات پکیج",
      content: (
        <MtFirstStep
          packageDetails={packageDetails}
          loading={packageData.loading}
          onContractSigned={() =>setIsContractSigned(!isContractSigned)}
        />
      ),
    },
    {
      title: "انتخاب تاریخ و زمان",
      content: (
        <MtSecondStep
          selectedMeetingRoom = {packageDetails?.product?.id}
          sessions={packageDetails?.sessions}
          onUserChangeSelectedDates={changeSelectedDates}
        />
      ),
    },
  ];

  const next = () => {
    setCurrent(current + 1);
  };
  const prev = () => {
    setCurrent(current - 1);
  };
  const items = steps.map((item) => ({
    key: item.title,
    title: item.title,
  }));
  return (
    <>
      <Row justify="center" align="middle">
        <Steps current={current} items={items} responsive />
        <Row style={{ marginTop: "30px", width: "100%" }} gutter={50}>
          {steps[current].content}
        </Row>
      </Row>
      <div
        style={{
          marginTop: 35,
          direction: "ltr",
        }}
      >
        {current < steps.length - 1 && (
          <Button
            type="primary"
            disabled={packageDetails?.contract ? !isContractSigned : false}
            onClick={() => next()}
          >
            مرحله بعد
          </Button>
        )}
        {current === steps.length - 1 && (
          <Button type="primary" onClick={() => createInvoice()}>
            پرداخت
          </Button>
        )}
        {current > 0 && (
          <Button
            style={{
              margin: "0 8px",
            }}
            onClick={() => prev()}
          >
            مرحله قبل
          </Button>
        )}
      </div>
    </>
  );
};

export default MtSinglePackage;
